import services from "@/services";

const state = {
  items: [],
  data: {},
};

const getters = {
  publicHolidayItems: (state) => state.items,
  publicHolidayDetail: (state) => state.data,
};

const mutations = {
  setPublicHolidayItems: (state, items) => {
    state.items = items;
  },
  setPublicHolidayDetail: (state, data) => {
    state.data = data;
  },
};

const actions = {
  getAll({ commit, dispatch }, param) {
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("public-holiday", param)
        .then((response) => {
          commit("setPublicHolidayItems", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  delete({ commit, dispatch }, publicHolidayId) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .delete(`public-holiday/${publicHolidayId}`)
        .then((response) => {
          commit("setPublicHolidayItems", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  create({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post(`public-holiday`, payload)
        .then((response) => {
          commit("setPublicHolidayItems", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
